module.exports = __webpack_public_path__ + "img/AceD.c6985df3.svg";